module.exports = __webpack_public_path__ + "img/40.7b8e539b.jpg";